<script>
// import { appConfig } from '@src/app.config'

import { services } from '../../utils/common-services'

// import { BIcon } from 'bootstrap-vue'

export default {
  /*  components: {
    BIcon,
  }, */
  /*  page: {
   // title: 'Dashboard',
    meta: [{ name: 'description', content: `Dashboard ${appConfig.title}` }],
  }, */

  data() {
    return {
      classToggle: false,
      menuToggle: false,
      minimizeFooter: false,
      profile: null,
      dashboard: null,
      isStaff: false,

      preloader: false,
    }
  },

  watch: {
    /*  classToggle(val, oldVal) {
      if (val !== oldVal) {
        //  this.scrollToTop()
      }
    }, */
    classToggle(val, oldVal) {
      if (val !== oldVal) {
        this.$root.$emit('changeMenu', {
          data: true,
        })
        this.$root.$emit('open', this.classToggle)
      }
    },
  },

  mounted: function() {
    //  this.$refs.circle.animate(1.0)
    // console.log(state.userDetails)
    //    this.profile = services.getCandidatesNameIcon(state.userDetails)
  },

  beforeMount() {
    this.getUser()
    document.title = this.$route.meta.title + ' | FC Form application'
  },
  beforeDestroy() {
    this.$store.commit('jv/clearRecords', { _jv: { type: 'dashboard' } })
    var doc = this.$refs.dashboard
    if (doc !== undefined) doc.innerHTML = ''
  },
  methods: {
    getUser() {
      this.profile = services.decodeJWT(services.getAuth())
      //  console.log(this.profile)
      this.isStaff = this.profile.is_staff
      this.$store
        .dispatch('jv/get', [
          'dashboard',
          {
            url: '/applicant/profile/summary',
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((token) => {
          this.dashboard = token
        })
        .catch((error) => {
          if (error) {
          }
          //   console.log(error)
        })
    },
  },
}
</script>

<template>
  <div ref="dashboard">
    <div :class="$style.mainWraper">
      <div :class="$style.innerWraper">
        <div :class="$style.profileSettings" class="w100">
          <div
            v-if="profile.dashboard !== 'applicant_dashboard'"
            :class="$style.breadCrumbWraper"
          >
            <h4>Dashboard </h4>
          </div>
          <div class="clear"></div>
          <div v-if="dashboard !== null" :class="$style.form">
            <div
              v-if="
                profile.dashboard == 'manager_dashboard' ||
                  profile.dashboard == 'staff_dashboard'
              "
              :class="$style.staffDashboard"
            >
              <h4 :class="$style.subHeader">Total Applicants</h4>
              <div :class="$style.bodyContentBorder"></div>
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#total-applicants' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabA]" class="FL">
                  <BIcon :class="$style.tabIcon" icon="person-fill"></BIcon>
                </span>
                <div class="FL">
                  <h5>Applicants</h5>
                  <h6>{{ dashboard.total }}</h6>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <div class="clear"></div>
            <div
              v-if="
                profile.dashboard == 'manager_dashboard' ||
                  profile.dashboard == 'staff_dashboard'
              "
              :class="$style.staffDashboard"
            >
              <h4 :class="$style.subHeader">UK Applicants</h4>
              <div :class="$style.bodyContentBorder"></div>
              <!-- <div :class="$style.dashboardTabs" class="mr20 mb20">
                <span :class="[$style.tabIconWrap, $style.tabA]" class="FL">
                  <BIcon :class="$style.tabIcon" icon="person-fill"></BIcon>
                </span>
                <div class="FL">
                  <h5>Total Applicants</h5>
                  <h6>2000</h6>
                </div>
                <div class="clear"></div>
              </div> -->
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#invited#GB' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabB]" class="FL">
                  <BIcon
                    :class="$style.tabIcon"
                    icon="person-plus-fill"
                  ></BIcon>
                </span>
                <div class="FL">
                  <h5>Invited</h5>
                  <h6>{{ dashboard['GB'].invited }}</h6>
                </div>
                <div class="clear"></div>
              </div>
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#rejected#GB' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabC]" class="FL">
                  <BIcon
                    :class="$style.tabIcon"
                    icon="person-dash-fill"
                  ></BIcon>
                </span>
                <div class="FL">
                  <h5>Rejected</h5>
                  <h6>{{ dashboard['GB'].rejected }}</h6>
                </div>
                <div class="clear"></div>
              </div>
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#submitted#GB' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabD]" class="FL">
                  <BIcon :class="$style.tabIcon" icon="check-circle"></BIcon>
                </span>
                <div class="FL">
                  <h5>Submitted</h5>
                  <h6>{{ dashboard['GB'].submitted }}</h6>
                </div>
                <div class="clear"></div>
              </div>
              <div class="clear"></div>
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#verified#GB' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabE]" class="FL">
                  <BIcon
                    :class="$style.tabIcon"
                    icon="person-check-fill"
                  ></BIcon>
                </span>
                <div class="FL">
                  <h5>Verified</h5>
                  <h6>{{ dashboard['GB'].verified }}</h6>
                </div>
                <div class="clear"></div>
              </div>
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#joined#GB' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabF]" class="FL">
                  <BIcon :class="$style.tabIcon" icon="person-circle"></BIcon>
                </span>
                <div class="FL">
                  <h5>Joined</h5>
                  <h6>{{ dashboard['GB'].joined }}</h6>
                </div>
                <div class="clear"></div>
              </div>
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#archived#GB' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabG]" class="FL">
                  <BIcon :class="$style.tabIcon" icon="archive-fill"></BIcon>
                </span>
                <div class="FL">
                  <h5>Archived</h5>
                  <h6>{{ dashboard['GB'].archived }}</h6>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <div class="clear"></div>
            <div
              v-if="
                profile.dashboard == 'manager_dashboard' ||
                  profile.dashboard == 'staff_dashboard'
              "
              :class="$style.staffDashboard"
            >
              <h4 :class="$style.subHeader">Scotland Applicants</h4>
              <div :class="$style.bodyContentBorder"></div>
              <!--  <div :class="$style.dashboardTabs" class="mr20 mb20">
                <span :class="[$style.tabIconWrap, $style.tabA]" class="FL">
                  <BIcon :class="$style.tabIcon" icon="person-fill"></BIcon>
                </span>
                <div class="FL">
                  <h5>Total Applicants</h5>
                  <h6>2000</h6>
                </div>
                <div class="clear"></div>
              </div> -->
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#invited#GBS' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabB]" class="FL">
                  <BIcon
                    :class="$style.tabIcon"
                    icon="person-plus-fill"
                  ></BIcon>
                </span>
                <div class="FL">
                  <h5>Invited</h5>
                  <h6>{{ dashboard['GBS'].invited }}</h6>
                </div>
                <div class="clear"></div>
              </div>
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#rejected#GBS' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabC]" class="FL">
                  <BIcon
                    :class="$style.tabIcon"
                    icon="person-dash-fill"
                  ></BIcon>
                </span>
                <div class="FL">
                  <h5>Rejected</h5>
                  <h6>{{ dashboard['GBS'].rejected }}</h6>
                </div>
                <div class="clear"></div>
              </div>
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#submitted#GBS' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabD]" class="FL">
                  <BIcon :class="$style.tabIcon" icon="check-circle"></BIcon>
                </span>
                <div class="FL">
                  <h5>Submitted</h5>
                  <h6>{{ dashboard['GBS'].submitted }}</h6>
                </div>
                <div class="clear"></div>
              </div>
              <div class="clear"></div>
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#verified#GBS' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabE]" class="FL">
                  <BIcon
                    :class="$style.tabIcon"
                    icon="person-check-fill"
                  ></BIcon>
                </span>
                <div class="FL">
                  <h5>Verified</h5>
                  <h6>{{ dashboard['GBS'].verified }}</h6>
                </div>
                <div class="clear"></div>
              </div>
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#joined#GBS' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabF]" class="FL">
                  <BIcon :class="$style.tabIcon" icon="person-circle"></BIcon>
                </span>
                <div class="FL">
                  <h5>Joined</h5>
                  <h6>{{ dashboard['GBS'].joined }}</h6>
                </div>
                <div class="clear"></div>
              </div>
              <div
                :class="$style.dashboardTabs"
                class="mr20 mb20"
                @click="$router.push({ path: '/applicants#archived#GBS' })"
              >
                <span :class="[$style.tabIconWrap, $style.tabG]" class="FL">
                  <BIcon :class="$style.tabIcon" icon="archive-fill"></BIcon>
                </span>
                <div class="FL">
                  <h5>Archived</h5>
                  <h6>{{ dashboard['GBS'].archived }}</h6>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <!-- Staff Dashboard -->

            <!-- Applicants Dashboard (Remove 'd-none' class for displaying this section)-->
            <div
              v-if="profile.dashboard == 'applicant_dashboard'"
              :class="$style.applicantsDashboard"
            >
              <div :class="$style.applicantDashboardHeader">
                <img
                  src="@assets/images/welcome_header.png"
                  width="100%"
                  alt="Welcome to the Swiis Foster Care Application Form"
                />
              </div>
              <div>
                <b-row
                  :class="[$style.rowAlign]"
                  class="align-items-center justify-content-center"
                >
                  <b-col cols="12" md="10" :class="$style.infoWraper">
                    <b-row>
                      <div class="pb30 pl15 pr15">
                        <!-- <h4
                          >Welcome to the Swiis Foster Care Application Form</h4
                        > -->
                        <p class="tl tc-sm">
                          We are delighted that you are joining the Swiis Foster
                          care family and once your application form has been
                          submitted, you will be one step closer to embarking on
                          your fostering career. The application form has been
                          designed to ensure that it is as straightforward as
                          possible and should not take you more than 30 minutes
                          to complete. To help you complete the form, we advise
                          that you have the following information to hand as you
                          will be asked to take pictures of certain documents
                          and upload these to your application form.
                        </p>
                        <ul :class="$style.applicantDashboard">
                          <li>
                            Identification Documents (Driving Licence, Passport,
                            Proof of Address and Proof of National Insurance
                            Number, Marriage Certificate).
                          </li>
                          <li>Details of any Criminal Offences. </li>
                          <li>
                            Address History for the last 10 years (this will
                            need to include the house number and full postcode,
                            as well as the dates lived at each address).
                          </li>
                          <li>
                            Your GP details.
                          </li>
                          <li>
                            Employment History. We require the names of all
                            employment you have undertaken going back 10 years.
                            Could you please further highlight any work that you
                            have undertaken involving children, young people or
                            vulnerable adults.
                          </li>
                          <li>
                            Voluntary Work Details (organisation name and
                            contact information) of any volunteering undertaken
                            with children, young people or vulnerable adults.
                          </li>
                          <li>
                            Armed Forces Details (rank, registration no. and
                            years served).
                          </li>
                          <li>
                            Personal References. The personal references must be
                            from people who are not related to you. References
                            must have known you for an extended period of time
                            and be in a position to comment on your parenting
                            and/or childcare experiences.
                          </li>
                          <li>
                            Ex-Partners Details (Name & Contact Info). In order
                            to carry out references we will require the details
                            of any ex-partner you have cohabited or have been
                            involved in a significant couple relationship,
                            whether or not that has involved jointly caring for
                            children, and whatever the time period of the
                            relationship. We also require details of any
                            ex-partner you have been married to, or parented a
                            child with, even if they you were not living
                            together at the same address.
                          </li>
                        </ul>
                        <p class="tl tc-sm"
                          >The above information is an essential part of your
                          fostering assessment, so please ensure that you
                          include all relevant details and documents required to
                          complete the form. For example we will contact your
                          employer for a reference and will speak with the
                          people that you have listed as your personal referees.
                          We are also required to contact the local authorities
                          where you have lived, therefore please ensure that you
                          include the addresses of where you have resided
                          previously (for all applicants if a joint
                          application). Any missing information will hold up the
                          application process considerably.<br /><br />If you
                          are concerned or unsure about submitting certain
                          information, or you have any questions about the
                          application form and/or how to complete this, please
                          do not hesitate to contact a member of the Foster Care
                          Recruitment team between 9am to 5pm Monday to Friday
                          on
                          <a
                            href="javascript:void(0)"
                            :class="$style.contactText"
                            >0333 577 1234</a
                          >, who will happily assist you in complete confidence.
                          We very much look forward to receiving your completed
                          application form and commencing with your fostering
                          assessment.</p
                        >
                        <p class="tl tc-sm"
                          ><b
                            >Best wishes<br />
                            The Recruitment Team</b
                          ></p
                        >
                        <button
                          :class="$style.goToForm"
                          class="buttonCommon tc"
                          type="button"
                          @click="$router.push({ name: 'applicant-form' })"
                          ><BIcon icon="file-earmark-text" class="mr5"></BIcon
                          >Start Application
                        </button>
                      </div>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </div>
            <!-- Applicants Dashboard -->
            <div class="clear"></div>
          </div>
          <div class="clear d-xl-block d-sm-block d-md-none"></div>
        </div>
      </div>
    </div>
    <footer id="footer" :class="$style.footerWraper">
      <div
        :class="
          minimizeFooter
            ? [$style.responsiveFooter, $style.mimimize]
            : [$style.responsiveFooter]
        "
      >
        <div class="position-relative">
          <a
            :class="$style.footerMinimize"
            class="position-absolute"
            @click="minimizeFooter = !minimizeFooter"
            ><BIcon class="" icon="grip-vertical"></BIcon
          ></a>
          <b-container fluid>
            <b-row>
              <b-col cols="4" sm="4">
                <button
                  :class="[$style.footerMenu, $style.menu]"
                  @click="classToggle = !classToggle"
                  ><BIcon
                    class=""
                    :class="$style.footerIcon"
                    icon="grid"
                  ></BIcon>
                  <span :class="$style.footerMenuTxt">Menu</span>
                </button>
              </b-col>
              <b-col cols="4" sm="4">
                <button
                  :class="[
                    $style.footerMenu,
                    $style.dashboard,
                    $style.selected,
                  ]"
                >
                  <BIcon icon="grid1x2"></BIcon>
                  <span :class="$style.footerMenuTxt">{{
                    profile.dashboard == 'applicant_dashboard'
                      ? 'Welcome'
                      : 'Dashboard'
                  }}</span>
                </button>
              </b-col>
              <b-col cols="4" sm="4">
                <button :class="[$style.footerMenu, $style.dashboard]">
                  <BIcon
                    class=""
                    :class="$style.footerIcon"
                    icon="person"
                    @click="$router.push({ name: 'profile-settings' })"
                  ></BIcon>
                  <span :class="$style.footerMenuTxt">Profile</span>
                </button>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <div class="clear"></div>
    </footer>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.form {
  padding: 20px 30px;
}

.applicantDashboardHeader {
  margin: -20px -35px;
  font-size: 20px;
  font-weight: bold;
  color: #ef5d20;
  text-align: center;
}

.contactText {
  display: inline-block;
  font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 15px;
  color: #4189f6 !important;
  text-decoration: none !important;
}

// dashboard
.infoWraper {
  width: 100%;
  margin: 20px 0;
  overflow: hidden;
  text-align: center;
  background: #fff;

  p {
    margin-top: 20px;
    font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 15px;
    color: #455d73;
  }

  h4 {
    width: 100%;
    font-family: 'SourceSansProSemibold', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 27px;
    color: #455d73;
  }

  .infoIconWraper {
    display: block;
    width: 54px;
    height: 54px;
    margin: 10px auto;
    font-size: 22px;
    line-height: 54px;
    color: #fff;
    text-align: center;
    background: #806bf8;
    border-radius: 50px;
  }

  .goToForm {
    padding: 7px 14px !important;
    font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji !important;
    font-size: 14px !important;
    color: #fff;
    background: #5bceae !important;
    border-radius: 50px !important;
  }
}

.subHeader {
  margin: 0;
  font-family: 'SourceSansProSemibold', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 20px;
  line-height: 29px;
  color: #959292;
}

.dashboardTabs {
  float: left;
  min-width: 270px;
  padding: 10px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.05);
  transition: all ease-in-out 0.3s;

  &:hover {
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.05);
    transition: all ease-in-out 0.3s;
    transform: scale(1.1);
  }

  .tabIconWrap {
    width: 54px;
    height: 54px;
    margin-right: 10px;
    font-size: 22px;
    line-height: 54px;
    color: #fff;
    text-align: center;
    border-radius: 5px;

    &.tabA {
      background: #806bf8;
    }
    &.tabB {
      background: #9599d6;
    }
    &.tabC {
      background: #ff808b;
    }
    &.tabD {
      background: #ffbf87;
    }
    &.tabE {
      background: #b24dff;
    }
    &.tabF {
      background: #00d47b;
    }
    &.tabG {
      background: #24c5ed;
    }
    &.tabH {
      background: #00adff;
    }
    &.tabI {
      background: #fdb00e;
    }
  }

  h5 {
    font-family: 'SourceSansProSemibold', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 15px;
    color: #455d73;
  }

  h6 {
    font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
    font-size: 18px;
    color: #9a9c9e;
  }
}

.applicantDashboard {
  li {
    position: relative;
    display: block;
    padding-left: 20px;
    margin-top: 15px;
    font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji !important;
    font-size: 15px !important;
    color: #455d73 !important;
    text-align: left;

    &::after {
      position: absolute;
      top: 6px;
      left: 0;
      width: 10px;
      height: 10px;
      content: '';
      background: #000;
      border-radius: 50px;
    }
  }
}
// dashboard

.mainWraper {
  width: 100%;
  min-height: calc(100vh - 55px);
  padding: 15px;
}

.innerWraper {
  position: relative;
  display: flex;
  min-height: calc(100vh - 85px);
  overflow: hidden;
  background: $color-body-inner-background;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.03);
}

.bodyContentBorder {
  width: 100%;
  height: 2px;
  margin: 20px 0;
  background: #f8f9f9;
}
// Page Title - Info text

// breadcrumb
.breadCrumbWraper {
  padding: 15px 30px;
  border-bottom: 2px solid #f8f9f9;

  h4 {
    margin: 0;
    font-family: 'SourceSansProSemibold', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 25px;
    line-height: 29px;
    color: #455d73;
  }
  span {
    font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    font-weight: 600;
    line-height: 29px;
    color: #8c959f;
  }

  svg {
    font-size: 16px;
  }
}
// breadcrumb

@media (max-width: 767px) {
  .form {
    padding: 20px 30px 50px;
  }

  .innerWraper {
    display: block !important;
  }

  .mainWraper {
    padding: 0 !important;
  }

  .dashboardTabs {
    min-width: 100%;
  }

  .bodyContentBorder {
    width: 100%;
    margin: 10px 0 20px;
  }

  // .responsiveFooter {
  //   display: block;
  // }

  .breadCrumbWraper {
    h4 {
      font-size: 20px;
      line-height: 24px;
    }
    span {
      font-size: 18px;
      line-height: 24px;
    }
  }

  .infoWraper {
    h4 {
      font-size: 20px;
    }
  }
}
</style>
